import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import {
  AppBar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  IconButton,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
  Box,
  Paper,
  Divider,
  FormControlLabel,
  Checkbox,
  useMediaQuery,
} from "@mui/material";
import jwtDecode from "jwt-decode";
import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
} from "react";
import OAuthService from "src/app/auth/services/oAuthService";
import AgGridTable from "../utilities/AgGridTable";
import CustomTooltip from "./customTooltip";
import Decline from "./Decline";
import { grey } from "@mui/material/colors";
import { toast } from "react-toastify";
import { useLocation, useParams } from "react-router-dom";
import FormPageHeader from "../utilities/FormPageHeader";
import { useFilterStore } from "./filterStore";
import { useTheme } from "@mui/material/styles";

const COLORS = {
  wg1: "#114635",
  wg2: "#255f38",
  sdr: "#0f828c",
  pblWg1: "#FF8503",
  pblWg2: "#F5AD18",
  neutral: "#000000",
};

const SpecialDiscountDetail = (props) => {
  const { id } = useParams();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { filters } = useFilterStore();
  const location = useLocation();
  const [gridApi, setGridApi] = useState(null);
  const gridRef = useRef();
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedRowsID, setSelectedRowsID] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [totalsGroup, setTotalsGroup] = useState();
  const [wg1SDR, setWg1SDR] = useState("");
  const [wg2SDR, setWg2SDR] = useState("");
  const [comment, setComment] = useState("");
  const [sdrData, setSdrData] = useState("");

  const discountUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}`;

  const token =
    localStorage &&
    localStorage.getItem("token") &&
    jwtDecode(localStorage.getItem("token"));
  const parsePercentValue = (params, label) => {
    const { newValue, oldValue } = params;

    if (newValue === null || newValue === undefined || newValue === "") {
      return 0;
    }

    const parsed = Number(newValue);

    if (Number.isNaN(parsed) || !Number.isFinite(parsed)) {
      toast.warning(`${label} must be a valid number.`);
      return oldValue ?? 0;
    }

    if (parsed > 100) {
      toast.warning(`${label} must be less than or equal to 100.`);
      return oldValue ?? 0;
    }

    return parsed;
  };
  const fetchProjectData = async () => {
    try {
      const res = await OAuthService.getList(
        discountUrl + `api/specialDiscounts/${id}/orders`,
      );
      const list = res.data._embedded.orders.map((data) => {
        data.project = data?.nolteProject?.project;
        if (data.sdrStatus === "PENDING" || data.sdrStatus === "WAITING") {
          data.sdrWg1 = data?.sdrWg1Applied;
          data.sdrWg2 = data?.sdrWg2Applied;
        }

        if (data?.stdDiscWg1 || data?.splDiscWg1 || data?.promoDiscWg1) {
          data.rcblStdDiscWg1 = Number(
            100 -
              ((100 - Number(data.stdDiscWg1)) *
                (100 - Number(data.splDiscWg1))) /
                100,
          ).toFixed(3);
          if (data?.promoDiscWg1) {
            data.rcblStdDiscWg1 = Number(
              100 -
                ((((100 - Number(data.stdDiscWg1)) *
                  (100 - Number(data.splDiscWg1))) /
                  100) *
                  (100 - Number(data.promoDiscWg1))) /
                  100,
            ).toFixed(3);
          }
        } else {
          data.rcblStdDiscWg1 = "";
        }

        if (data?.stdDiscWg1 || data.sdrWg1) {
          data.cumDiscWg1 =
            100 -
            ((100 - Number(data?.rcblStdDiscWg1)) *
              (100 - Number(data?.sdrWg1))) /
              100;
        } else {
          data.cumDiscWg1 = 0;
        }

        if (data?.stdDiscWg2 || data?.splDiscWg2 || data?.promoDiscWg2) {
          data.rcblStdDiscWg2 = Number(
            100 -
              ((100 - Number(data.stdDiscWg2)) *
                (100 - Number(data.splDiscWg2))) /
                100,
          ).toFixed(3);
          if (data?.promoDiscWg2) {
            data.rcblStdDiscWg2 = Number(
              100 -
                ((((100 - Number(data.stdDiscWg2)) *
                  (100 - Number(data.splDiscWg2))) /
                  100) *
                  (100 - Number(data.promoDiscWg2))) /
                  100,
            ).toFixed(3);
          }
        } else {
          data.rcblStdDiscWg2 = "";
        }

        if (data?.stdDiscWg2 || data?.sdrWg2) {
          data.cumDiscWg2 =
            100 -
            ((100 - Number(data?.rcblStdDiscWg2)) *
              (100 - Number(data?.sdrWg2))) /
              100;
        } else {
          data.cumDiscWg2 = 0;
        }
        if (
          data?.stdDiscWG1Payable ||
          data?.splDiscWG1Payable ||
          data?.promoDiscWg1Payable
        ) {
          data.pblStdDiscWg1 = Number(
            100 -
              ((((100 - Number(data?.stdDiscWG1Payable)) *
                (100 - Number(data?.splDiscWG1Payable))) /
                100) *
                (100 - Number(data?.promoDiscWg1Payable))) /
                100,
          ).toFixed(3);
        } else {
          data.pblStdDiscWg1 = 0;
        }
        if (
          data?.stdDiscWG2Payable ||
          data?.splDiscWG2Payable ||
          data?.promoDiscWg2Payable
        ) {
          data.pblStdDiscWg2 = Number(
            100 -
              ((((100 - Number(data?.stdDiscWG2Payable)) *
                (100 - Number(data?.splDiscWG2Payable))) /
                100) *
                (100 - Number(data?.promoDiscWg2Payable))) /
                100,
          ).toFixed(3);
        } else {
          data.pblStdDiscWg2 = 0;
        }

        if (
          data?.rcblStdDiscWg1 ||
          data?.rcblStdDiscWg2 ||
          data?.revisedLpWg1 ||
          data?.revisedLpWg2
        ) {
          data.nmeRcblStd =
            Number(data?.revisedLpWg1) -
            Number(data?.revisedLpWg1) * (Number(data?.rcblStdDiscWg1) / 100) +
            (Number(data?.revisedLpWg2) -
              Number(data?.revisedLpWg2) *
                (Number(data?.rcblStdDiscWg2) / 100));
        } else {
          data.nmeRcblStd = "";
        }

        if (data?.pblStdDiscWg1 || data?.sdpWg1) {
          data.pblCumDiscWg1 =
            100 -
            ((100 - Number(data?.pblStdDiscWg1)) *
              (100 - Number(data?.sdpWg1))) /
              100;
        } else {
          data.pblCumDiscWg1 = 0;
        }

        if (
          data?.cumDiscWg1 ||
          data?.cumDiscWg2 ||
          data?.revisedLpWg1 ||
          data?.revisedLpWg2
        ) {
          data.nmeRcbl =
            Number(data?.revisedLpWg1) -
            Number(data?.revisedLpWg1) * (Number(data?.cumDiscWg1) / 100) +
            Number(data?.revisedLpWg2) -
            Number(data?.revisedLpWg2) * (Number(data?.cumDiscWg2) / 100);
        } else {
          data.nmeRcbl = "";
        }

        if (data?.pblStdDiscWg2 || data?.sdpWg2) {
          data.pblCumDiscWg2 =
            100 -
            ((100 - Number(data?.pblStdDiscWg2)) *
              (100 - Number(data?.sdpWg2))) /
              100;
        } else {
          data.pblCumDiscWg2 = 0;
        }

        if (
          data?.cumDiscWg2 ||
          data?.cumDiscWg1 ||
          data?.revisedLpWg1 ||
          data?.revisedLpWg2
        ) {
          data.nmeRcblAfterSdr =
            Number(data?.revisedLpWg1) -
            Number(data?.revisedLpWg1) * (Number(data?.cumDiscWg1) / 100) +
            (Number(data?.revisedLpWg2) -
              Number(data?.revisedLpWg2) * (Number(data?.cumDiscWg2) / 100));
        } else {
          data.nmeRcblAfterSdr = "";
        }

        if (
          data?.pblCumDiscWg1 ||
          data?.pblCumDiscWg2 ||
          data?.revisedLpWg1 ||
          data?.revisedLpWg2
        ) {
          data.nmePbl =
            Number(data?.revisedLpWg1) -
            Number(data?.revisedLpWg1) * (Number(data?.pblCumDiscWg1) / 100) +
            (Number(data?.revisedLpWg2) -
              Number(data?.revisedLpWg2) * (Number(data?.pblCumDiscWg2) / 100));
        } else {
          data.nmePbl = 0;
        }
        if (
          data?.pblCumDiscWg1 ||
          data?.pblCumDiscWg2 ||
          data?.revisedLpWg1 ||
          data?.revisedLpWg2
        ) {
          data.nmePblAfterSdp =
            Number(data?.revisedLpWg1) -
            Number(data?.revisedLpWg1) * (Number(data?.pblCumDiscWg1) / 100) +
            (Number(data?.revisedLpWg2) -
              Number(data?.revisedLpWg2) * (Number(data?.pblCumDiscWg2) / 100));
        } else {
          data.nmePblAfterSdp = 0;
        }
        if (data?.nmeRcblAfterSdr || data?.nmePbl) {
          data.marginAftSplDisc =
            Number(data?.nmeRcblAfterSdr) - Number(data?.nmePbl);
        } else {
          data.marginAftSplDisc = "";
        }

        if (data?.marginAftSplDisc && data?.nmeRcblAfterSdr) {
          data.marginAftSplDiscPercent =
            (Number(data?.marginAftSplDisc) / Number(data?.nmeRcblAfterSdr)) *
            100;
        } else {
          data.marginAftSplDiscPercent = "";
        }

        if (data?.nmeRcblStd || data?.nmeRcblAfterSdr) {
          data.gestureToCustomer =
            Number(data?.nmeRcblStd) - Number(data?.nmeRcblAfterSdr);
        } else {
          data.gestureToCustomer = "";
        }

        if (data?.gestureToCustomer || data?.nmeRcblStd) {
          data.gesture =
            (Number(data?.gestureToCustomer) / Number(data?.nmeRcblStd)) * 100;
        } else {
          data.gesture = "";
        }

        if (data?.nmeRcblStd || data?.nmePbl) {
          data.stdMargin = Number(data?.nmeRcblStd) - Number(data?.nmePbl);
        } else {
          data.stdMargin = "";
        }

        if (
          data?.pblStdDiscWg1 ||
          data?.pblStdDiscWg2 ||
          data?.revisedLpWg1 ||
          data?.revisedLpWg2
        ) {
          data.nmePblStd =
            Number(data?.revisedLpWg1) -
            Number(data?.revisedLpWg1) * (Number(data?.pblStdDiscWg1) / 100) +
            (Number(data?.revisedLpWg2) -
              Number(data?.revisedLpWg2) * (Number(data?.pblStdDiscWg2) / 100));
        } else {
          data.nmePblStd = 0;
        }

        if (
          data?.pblCumDiscWg1 ||
          data?.pblCumDiscWg2 ||
          data?.revisedLpWg1 ||
          data?.revisedLpWg2
        ) {
          data.nmePblAfterSdr =
            Number(data?.revisedLpWg1) -
            Number(data?.revisedLpWg1) * (Number(data?.pblCumDiscWg1) / 100) +
            (Number(data?.revisedLpWg2) -
              Number(data?.revisedLpWg2) * (Number(data?.pblCumDiscWg2) / 100));
        } else {
          data.nmePblAfterSdr = 0;
        }

        if (data?.nmePblStd || data?.nmeRcbl) {
          data.stdPblMargin = Number(data?.nmeRcbl) - Number(data?.nmePblStd);
        } else {
          data.stdPblMargin = 0;
        }

        if (data?.nmePblAfterSdp || data?.nmeRcbl) {
          data.pblMarginAftSplDisc =
            Number(data?.nmeRcbl) - Number(data?.nmePblAfterSdp);
        } else {
          data.pblMarginAftSplDisc = 0;
        }

        if (data?.pblMarginAftSplDisc || data?.nmeRcbl) {
          data.pblMarginAftSplDiscPercent =
            (Number(data?.pblMarginAftSplDisc) / Number(data?.nmeRcbl)) * 100;
        } else {
          data.pblMarginAftSplDiscPercent = 0;
        }

        if (data?.nmePblStd || data?.nmePblAfterSdp) {
          data.gestureToPbl =
            Number(data?.nmePblStd) - Number(data?.nmePblAfterSdp);
        } else {
          data.gestureToPbl = 0;
        }

        if (data?.gestureToPbl || data?.nmePblStd) {
          data.gesturePbl =
            (Number(data?.gestureToPbl) / Number(data?.nmePblStd)) * 100;
        } else {
          data.gesturePbl = 0;
        }

        return data;
      });
      setRowData(list);
    } catch (error) {
      toast.error(error?.response?.data?.errorMessage || error.message);
    }
  };
  const getSpecialDiscountById = async (id) => {
    try {
      const response = await OAuthService.getList(
        discountUrl + `api/specialDiscounts/${id}`,
      );
      setSdrData(response?.data);
      setComment(response?.data?.comment);
    } catch (error) {
      toast.error(error?.response?.data?.errorMessage || error.message);
    }
  };
  useEffect(() => {
    if (id) {
      fetchProjectData();
      getSpecialDiscountById(id);
    }
  }, [id]);
  const showStatusIcon = (props) => {
    let statusIcon = "";
    if (props?.data?.sdrStatus === "PENDING") {
      statusIcon = (
        <>
          <FuseSvgIcon size={18} style={{ fill: "#fe9705", marginRight: 4 }}>
            material-solid:access_time_filled
          </FuseSvgIcon>
          {props?.value}
        </>
      );
    }
    if (props?.data?.sdrStatus === "WAITING") {
      statusIcon = (
        <>
          <FuseSvgIcon size={18} style={{ fill: "#fcd260", marginRight: 4 }}>
            material-solid:timelapse
          </FuseSvgIcon>
          {props?.value}
        </>
      );
    }
    if (props?.data?.sdrStatus === "APPROVED") {
      statusIcon = (
        <>
          <FuseSvgIcon size={18} style={{ fill: "#3ac430", marginRight: 4 }}>
            material-solid:check_circle
          </FuseSvgIcon>
          {props?.value}
        </>
      );
    }
    if (props?.data?.sdrStatus === "REJECTED") {
      statusIcon = (
        <>
          <FuseSvgIcon size={18} style={{ fill: "#d11313", marginRight: 4 }}>
            material-solid:do_not_disturb
          </FuseSvgIcon>
          {props?.value}
        </>
      );
    }
    if (props?.data?.sdrStatus === "DECLINED") {
      statusIcon = (
        <>
          <FuseSvgIcon size={18} style={{ fill: "#d11313", marginRight: 4 }}>
            material-solid:cancel
          </FuseSvgIcon>
          {props?.value}
        </>
      );
    }
    return (
      <p className="flex items-center">
        {props?.column?.colId === "customerNum" && props?.value
          ? statusIcon
          : props?.value}
      </p>
    );
  };

  const showFixedValue = (props) => {
    const options = {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    };
    return (
      <span>
        <p>
          {props?.value
            ? Number(props?.value).toLocaleString("en-US", options)
            : 0.0}
        </p>
      </span>
    );
  };
  const showDiscountPercent = (props) => {
    return <p>{props?.value && <>{Number(props?.value).toFixed(3)}%</>}</p>;
  };

  const handleDownloadAttachment = async (selectedDocument) => {
    let id = selectedDocument?.id;
    const download = await OAuthService.getDownload(
      discountUrl + `api/downloadOrderFile?orderAttachmentId=${id}`,
    );
    const blob = download?.data;
    if (blob) {
      const url = window.URL.createObjectURL(
        new Blob([blob], { type: "application/octet-stream" }),
      );
      const link = document.createElement("a");
      link.href = url;
      link.download = selectedDocument.attachmentName;
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    }
  };

  const showAttachment = useCallback((props) => {
    return (
      props?.value && (
        <IconButton
          size="small"
          className="p-0"
          onClick={() => showDocument(props?.value)}
        >
          <FuseSvgIcon>heroicons-outline:paper-clip</FuseSvgIcon>
        </IconButton>
      )
    );
  });
  const showDocument = (document) => {
    handleDownloadAttachment(document);
  };

  useEffect(() => {
    const options = {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    };

    const allRows = rowData || [];

    if (!allRows?.length) return;

    const totalPrice = allRows.reduce(
      (a, b) => a + (Number(b.totalRevisedLpWg1Wg2) || 0),
      0,
    );
    const totalRCBLasPerPDS = allRows.reduce(
      (a, b) => a + (Number(b.nmeRcblStd) || 0),
      0,
    );
    const totalRCBAfterSDR = allRows.reduce(
      (a, b) => a + (Number(b.nmeRcblAfterSdr) || 0),
      0,
    );
    const totalGestureToCustomer = totalRCBLasPerPDS - totalRCBAfterSDR;
    const totalPercentageGestureToCustomer = totalRCBLasPerPDS
      ? (totalGestureToCustomer / totalRCBLasPerPDS) * 100
      : 0;

    const totalMarginAsPerPDS = allRows.reduce(
      (a, b) => a + (Number(b.stdMargin) || 0),
      0,
    );
    const totalAfterSDR = allRows.reduce(
      (a, b) => a + (Number(b.marginAftSplDisc) || 0),
      0,
    );
    const totalPercentageMargin = totalRCBAfterSDR
      ? (totalAfterSDR / totalRCBAfterSDR) * 100
      : 0;

    const totalPblAsPerPds = allRows.reduce(
      (a, b) => a + (Number(b.nmePblStd) || 0),
      0,
    );
    const totalPBLAfterSDP = allRows.reduce(
      (a, b) => a + (Number(b.nmePblAfterSdp) || 0),
      0,
    );
    const totalGestureFromFac = allRows.reduce(
      (a, b) => a + (Number(b.gestureToPbl) || 0),
      0,
    );
    const totalPercentageGestureToPbl = totalPblAsPerPds
      ? (totalGestureFromFac / totalPblAsPerPds) * 100
      : 0;

    const TotalOrder = allRows.length;

    setTotalsGroup({
      totalListPrice: totalPrice
        ? Number(totalPrice).toLocaleString("en-US", options)
        : 0.0,
      totalRCBLSTD: totalRCBLasPerPDS
        ? Number(totalRCBLasPerPDS).toLocaleString("en-US", options)
        : 0.0,
      totalRCBAftSDR: totalRCBAfterSDR
        ? Number(totalRCBAfterSDR).toLocaleString("en-US", options)
        : 0.0,
      totalGestureCustomer: totalGestureToCustomer
        ? Number(totalGestureToCustomer).toLocaleString("en-US", options)
        : 0.0,
      perGestureCust: totalPercentageGestureToCustomer
        ? Number(totalPercentageGestureToCustomer).toFixed(3)
        : 0.0,
      totalMarginPDS: totalMarginAsPerPDS
        ? Number(totalMarginAsPerPDS).toLocaleString("en-US", options)
        : 0.0,
      totalMarginPercentage: totalPercentageMargin
        ? Number(totalPercentageMargin).toFixed(3)
        : 0.0,
      totalMarginAftSDR: totalAfterSDR
        ? Number(totalAfterSDR).toLocaleString("en-US", options)
        : 0.0,
      TotalOrder: TotalOrder
        ? Number(TotalOrder).toLocaleString("en-US", options)
        : 0.0,
      totalPBLPDS: totalPblAsPerPds
        ? Number(totalPblAsPerPds).toLocaleString("en-US", options)
        : 0.0,
      totalPBLAftSDP: totalPBLAfterSDP
        ? Number(totalPBLAfterSDP).toLocaleString("en-US", options)
        : 0.0,
      totalGestureFac: totalGestureFromFac
        ? Number(totalGestureFromFac).toLocaleString("en-US", options)
        : 0.0,
      totalPercentageGesture: totalPercentageGestureToPbl
        ? Number(totalPercentageGestureToPbl).toFixed(3)
        : 0.0,
    });
  }, [rowData, selectedRows]);

  const parseNum = (v) => {
    if (v === null || v === undefined || v === "") return 0;
    const n = Number(v);
    return Number.isNaN(n) ? 0 : n;
  };

  const onCellValueChanged = (params) => {
    const { colDef, data, api } = params;
    if (!(colDef.field === "sdrWg1" || colDef.field === "sdrWg2")) return;
    if (
      newValue !== null &&
      newValue !== "" &&
      Number.isNaN(Number(newValue))
    ) {
      toast.warning(`Invalid value entered for ${colDef.headerName}.`);
      node.setDataValue(colDef.field, oldValue ?? 0);
      return;
    }

    const updated = { ...data };

    const revisedLpWg1 = parseNum(updated.revisedLpWg1);
    const revisedLpWg2 = parseNum(updated.revisedLpWg2);

    const rcblStdDiscWg1 = parseNum(updated.rcblStdDiscWg1);
    const rcblStdDiscWg2 = parseNum(updated.rcblStdDiscWg2);

    const pblStdDiscWg1 = parseNum(updated.pblStdDiscWg1);
    const pblStdDiscWg2 = parseNum(updated.pblStdDiscWg2);

    const sdrWg1 = parseNum(updated.sdrWg1);
    const sdrWg2 = parseNum(updated.sdrWg2);

    const sdpWg1 = parseNum(updated.sdpWg1);
    const sdpWg2 = parseNum(updated.sdpWg2);

    updated.cumDiscWg1 =
      rcblStdDiscWg1 || sdrWg1
        ? 100 - ((100 - rcblStdDiscWg1) * (100 - sdrWg1)) / 100
        : 0;

    updated.cumDiscWg2 =
      rcblStdDiscWg2 || sdrWg2
        ? 100 - ((100 - rcblStdDiscWg2) * (100 - sdrWg2)) / 100
        : 0;

    updated.pblCumDiscWg1 =
      pblStdDiscWg1 || sdpWg1
        ? 100 - ((100 - pblStdDiscWg1) * (100 - sdpWg1)) / 100
        : 0;

    updated.pblCumDiscWg2 =
      pblStdDiscWg2 || sdpWg2
        ? 100 - ((100 - pblStdDiscWg2) * (100 - sdpWg2)) / 100
        : 0;

    const discounted = (price, discPercent) =>
      price - price * (parseNum(discPercent) / 100);

    updated.nmeRcblStd =
      rcblStdDiscWg1 || rcblStdDiscWg2 || revisedLpWg1 || revisedLpWg2
        ? discounted(revisedLpWg1, rcblStdDiscWg1) +
          discounted(revisedLpWg2, rcblStdDiscWg2)
        : 0;

    updated.nmeRcblAfterSdr =
      updated.cumDiscWg1 || updated.cumDiscWg2 || revisedLpWg1 || revisedLpWg2
        ? discounted(revisedLpWg1, updated.cumDiscWg1) +
          discounted(revisedLpWg2, updated.cumDiscWg2)
        : 0;

    updated.nmeRcbl =
      updated.cumDiscWg1 || updated.cumDiscWg2 || revisedLpWg1 || revisedLpWg2
        ? discounted(revisedLpWg1, updated.cumDiscWg1) +
          discounted(revisedLpWg2, updated.cumDiscWg2)
        : 0;

    updated.nmePblStd =
      pblStdDiscWg1 || pblStdDiscWg2 || revisedLpWg1 || revisedLpWg2
        ? discounted(revisedLpWg1, pblStdDiscWg1) +
          discounted(revisedLpWg2, pblStdDiscWg2)
        : 0;

    updated.nmePblAfterSdp =
      updated.pblCumDiscWg1 ||
      updated.pblCumDiscWg2 ||
      revisedLpWg1 ||
      revisedLpWg2
        ? discounted(revisedLpWg1, updated.pblCumDiscWg1) +
          discounted(revisedLpWg2, updated.pblCumDiscWg2)
        : 0;

    updated.nmePbl =
      updated.pblCumDiscWg1 ||
      updated.pblCumDiscWg2 ||
      revisedLpWg1 ||
      revisedLpWg2
        ? discounted(revisedLpWg1, updated.pblCumDiscWg1) +
          discounted(revisedLpWg2, updated.pblCumDiscWg2)
        : 0;
    updated.nmePblAfterSdr =
      updated.pblCumDiscWg1 ||
      updated.pblCumDiscWg2 ||
      revisedLpWg1 ||
      revisedLpWg2
        ? discounted(revisedLpWg1, updated.pblCumDiscWg1) +
          discounted(revisedLpWg2, updated.pblCumDiscWg2)
        : 0;

    updated.stdMargin =
      updated.nmeRcblStd || updated.nmePbl
        ? updated.nmeRcblStd - updated.nmePbl
        : 0;

    updated.marginAftSplDisc =
      updated.nmeRcblAfterSdr || updated.nmePbl
        ? updated.nmeRcblAfterSdr - updated.nmePbl
        : 0;

    updated.marginAftSplDiscPercent =
      updated.marginAftSplDisc && updated.nmeRcblAfterSdr
        ? (Number(updated.marginAftSplDisc) / Number(updated.nmeRcblAfterSdr)) *
          100
        : 0;

    updated.gestureToCustomer =
      updated.nmeRcblStd || updated.nmeRcblAfterSdr
        ? Number(updated.nmeRcblStd) - Number(updated.nmeRcblAfterSdr)
        : 0;

    updated.gesture =
      updated.gestureToCustomer && updated.nmeRcblStd
        ? (Number(updated.gestureToCustomer) / Number(updated.nmeRcblStd)) * 100
        : 0;

    updated.stdPblMargin =
      updated.nmeRcbl || updated.nmePblStd
        ? Number(updated.nmeRcbl) - Number(updated.nmePblStd)
        : 0;

    updated.pblMarginAftSplDisc =
      updated.nmePblAfterSdp || updated.nmeRcbl
        ? Number(updated.nmeRcbl) - Number(updated.nmePblAfterSdp)
        : 0;

    updated.pblMarginAftSplDiscPercent =
      updated.pblMarginAftSplDisc && updated.nmeRcbl
        ? (Number(updated.pblMarginAftSplDisc) / Number(updated.nmeRcbl)) * 100
        : 0;

    updated.gestureToPbl =
      updated.nmePblStd || updated.nmePblAfterSdp
        ? Number(updated.nmePblStd) - Number(updated.nmePblAfterSdp)
        : 0;

    updated.gesturePbl =
      updated.gestureToPbl && updated.nmePblStd
        ? (Number(updated.gestureToPbl) / Number(updated.nmePblStd)) * 100
        : 0;

    setRowData((prev) => {
      const next = prev.map((r) => (r.id === updated.id ? updated : r));
      return next;
    });

    try {
      const rowNode = api.getRowNode(updated.id);
      if (rowNode) {
        rowNode.setData(updated);
      } else {
        api.setRowData ? api.setRowData() : api.refreshCells({ force: true });
      }
    } catch (err) {
      api.refreshCells({ force: true });
    }

    selectedRowsID.forEach((id) => {
      const rn = api.getRowNode(id);
      if (rn) rn.setSelected(true);
    });
  };

  const [columnDefsSDR, setColumnDefsSDR] = useState([
    {
      headerName: "Order",
      headerClass: "grp-header grp-neutral",
      marryChildren: true,
      children: [
        {
          checkboxSelection: true,
           pinned: isMobile ? false : true,
          minWidth: 50,
          maxWidth: 50,
          editable: false,
        },
        {
          field: "customerNum",
          headerName: "Customer",
          cellRenderer: (params) => showStatusIcon(params),
          minWidth: 100,
           pinned: isMobile ? false : true,
          cellStyle: {
            justifyContent: "center",
            textAlign: "center",
          },
        },
        {
          field: "abNumber",
          minWidth: 75,
           pinned: isMobile ? false : true,
          cellStyle: {
            justifyContent: "center",
            textAlign: "center",
          },
        },
        { field: "commissionName", minWidth: 150,  pinned: isMobile ? false : true, },

        {
          field: "showroomName",
          headerName: "Showroom",
          minWidth: 125,
        },
        {
          field: "vendorShortKey",
          headerName: "Product",
          minWidth: 60,
        },
        { field: "orderCategory", headerName: "Category", minWidth: 60 },
        {
          field: "territory",
          headerName: "Territory",
          minWidth: 50,
        },

        {
          field: "project",
          headerName: "Order Referance",
          hide: true,
          cellStyle: {
            justifyContent: "center",
            textAlign: "center",
          },
        },
      ],
    },
    {
      headerName: "List price",
      headerClass: "grp-header grp-neutral",
      marryChildren: true,
      children: [
        {
          field: "revisedLpWg1",
          headerName: "List Price Wg1",
          cellClass: "prectangePriceRightAlign",
          cellRenderer: showFixedValue,
          minWidth: 70,
        },
        {
          field: "revisedLpWg2",
          headerName: "List Price Wg2",
          cellClass: "prectangePriceRightAlign",
          cellRenderer: showFixedValue,
          minWidth: 70,
        },
        {
          field: "totalRevisedLpWg1Wg2",
          headerName: "Total List Price",
          cellClass: "prectangePriceRightAlign",
          cellRenderer: showFixedValue,
          minWidth: 70,
        },
      ],
    },
    {
      headerName: "WG1",
      headerClass: "grp-header grp-wg1",
      marryChildren: true,
      children: [
        {
          field: "rcblStdDiscWg1",
          headerName: "RCBL STD DISC.WG1",
          cellClass: "prectangePriceRightAlign",
          cellStyle: { backgroundColor: COLORS.wg1, color: "#fff" },
          cellRenderer: showDiscountPercent,
          minWidth: 70,
          tooltipField: "rcblStdDiscWg1",
          tooltipComponent: CustomTooltip,
        },
        {
          field: "sdrWg1",
          headerName: "SDR WG1",
          type: "editableColumn",
          cellRenderer: showDiscountPercent,
          valueParser: (params) => parsePercentValue(params, "SDR WG1"),
          minWidth: 70,
          valueFormatter: (params) =>
            params?.data?.sdrWg1 === null ? 0 : params?.data?.sdrWg1,
          valueGetter: (params) =>
            params?.data?.sdrWg1 === null ? 0 : params?.data?.sdrWg1,
          cellClass: "prectangePriceRightAlign",
          cellStyle: { backgroundColor: COLORS.sdr, color: "#fff" },
          editable: (params) => {
            const status = params?.data?.sdrStatus;

            const hasMD = token?.scope.includes("ROLE_MD");
            const hasOtherRole =
              token?.scope?.includes("ROLE_ORDERPRO") ||
              token?.scope?.includes("ROLE_IAM") ||
              token?.scope?.includes("ROLE_SOPDIR") ||
              token?.scope?.includes("ROLE_ADMIN");

            if (hasMD) {
              return ["PENDING", "APPROVED", "REJECTED"].includes(status);
            } else if (hasOtherRole) {
              return ["PENDING", "WAITING", "REJECTED"].includes(status);
            } else {
              return false;
            }
          },
        },
        {
          field: "cumDiscWg1",
          headerName: "CUM.DISC WG1",
          cellRenderer: showDiscountPercent,
          minWidth: 70,
          cellClass: "prectangePriceRightAlign",
          cellStyle: { backgroundColor: COLORS.wg1, color: "#fff" },
        },
      ],
    },
    {
      headerName: "WG2",
      headerClass: "grp-header grp-wg2",
      marryChildren: true,
      children: [
        {
          field: "rcblStdDiscWg2",
          headerName: "RCBL STD DISC.WG2",
          cellRenderer: showDiscountPercent,
          minWidth: 70,
          tooltipField: "rcblStdDiscWg2",
          tooltipComponent: CustomTooltip,
          cellClass: "prectangePriceRightAlign",
          cellStyle: { backgroundColor: COLORS.wg2, color: "#fff" },
        },
        {
          field: "sdrWg2",
          headerName: "SDR WG2",
          cellRenderer: showDiscountPercent,
          minWidth: 70,
          valueParser: (params) => parsePercentValue(params, "SDR WG2"),
          valueFormatter: (params) =>
            params?.data?.sdrWg2 === null ? 0 : params?.data?.sdrWg2,
          valueGetter: (params) =>
            params?.data?.sdrWg2 === null ? 0 : params?.data?.sdrWg2,
          cellClass: "prectangePriceRightAlign",
          cellStyle: { backgroundColor: COLORS.sdr, color: "#fff" },
          editable: (params) => {
            const status = params?.data?.sdrStatus;

            const hasMD = token?.scope.includes("ROLE_MD");
            const hasOtherRole =
              token?.scope?.includes("ROLE_ORDERPRO") ||
              token?.scope?.includes("ROLE_IAM") ||
              token?.scope?.includes("ROLE_SOPDIR") ||
              token?.scope?.includes("ROLE_ADMIN");

            if (hasMD) {
              return ["PENDING", "APPROVED", "REJECTED"].includes(status);
            } else if (hasOtherRole) {
              return ["PENDING", "WAITING", "REJECTED"].includes(status);
            } else {
              return false;
            }
          },
        },
        {
          field: "cumDiscWg2",
          headerName: "CUM.DISC WG2",
          cellRenderer: showDiscountPercent,
          minWidth: 70,
          cellClass: "prectangePriceRightAlign",
          cellStyle: { backgroundColor: COLORS.wg2, color: "#fff" },
        },
      ],
    },
    {
      headerName: "PBL WG1",
      headerClass: "grp-header grp-pbl-wg1",
      marryChildren: true,
      children: [
        {
          field: "pblStdDiscWg1",
          headerName: "PBL STD DISC.WG1",
          cellRenderer: showDiscountPercent,
          cellClass: "prectangePriceRightAlign",
          cellStyle: { backgroundColor: COLORS.pblWg1, color: "#fff" },
          minWidth: 70,
          tooltipField: "rcblStdDiscWg1",
          tooltipComponent: CustomTooltip,
        },
        {
          field: "sdpWg1",
          headerName: "SDP WG1",
          cellClass: "prectangePriceRightAlign",
          cellStyle: { backgroundColor: COLORS.pblWg1, color: "#fff" },
          cellRenderer: showDiscountPercent,
          minWidth: 70,
        },
        {
          field: "pblCumDiscWg1",
          headerName: "PBL CUM DISC WG1",
          cellRenderer: showDiscountPercent,
          cellClass: "prectangePriceRightAlign",
          cellStyle: { backgroundColor: COLORS.pblWg1, color: "#fff" },
          minWidth: 70,
        },
      ],
    },
    {
      headerName: "PBL WG2",
      headerClass: "grp-header grp-pbl-wg2",
      marryChildren: true,
      children: [
        {
          field: "pblStdDiscWg2",
          headerName: "PBL STD DISC WG2",
          cellRenderer: showDiscountPercent,
          minWidth: 70,
          cellClass: "prectangePriceRightAlign",
          cellStyle: { backgroundColor: COLORS.pblWg2, color: "#fff" },
          tooltipField: "rcblStdDiscWg1",
          tooltipComponent: CustomTooltip,
        },
        {
          field: "sdpWg2",
          headerName: "SDP WG2",
          cellClass: "prectangePriceRightAlign",
          cellStyle: { backgroundColor: COLORS.pblWg2, color: "#fff" },
          cellRenderer: showDiscountPercent,
          minWidth: 70,
        },
        {
          field: "pblCumDiscWg2",
          headerName: "PBL CUM DISC WG2",
          cellClass: "prectangePriceRightAlign",
          cellStyle: { backgroundColor: COLORS.pblWg2, color: "#fff" },
          cellRenderer: showDiscountPercent,
          minWidth: 70,
        },
      ],
    },
    {
      headerName: "RCBL summary",
      headerClass: "grp-header grp-wg1",
      marryChildren: true,
      children: [
        {
          field: "nmePbl",
          headerName: "NFZE PBL",
          cellStyle: { backgroundColor: COLORS.wg1, color: "#fff" },
          cellClass: "prectangePriceRightAlign",
          minWidth: 70,
          cellRenderer: showFixedValue,
        },
        {
          field: "nmeRcblStd",
          headerName: "NFZE RCBL (STD)",
          cellClass: "prectangePriceRightAlign",
          cellStyle: { backgroundColor: COLORS.wg1, color: "#fff" },
          minWidth: 70,
          cellRenderer: showFixedValue,
        },
        {
          field: "nmeRcblAfterSdr",
          headerName: "NFZE RCBL (AFTER SDR)",
          cellClass: "prectangePriceRightAlign",
          cellStyle: { backgroundColor: COLORS.wg1, color: "#fff" },
          minWidth: 80,
          cellRenderer: showFixedValue,
        },
        {
          field: "stdMargin",
          headerName: "STD MARGIN.",
          cellClass: "prectangePriceRightAlign",
          cellStyle: { backgroundColor: COLORS.wg1, color: "#fff" },
          minWidth: 70,
          cellRenderer: showFixedValue,
        },
        {
          field: "marginAftSplDisc",
          headerName: "MARGIN AFT SPL DISC",
          minWidth: 70,
          cellRenderer: showFixedValue,
          cellClass: "prectangePriceRightAlign",
          cellStyle: { backgroundColor: COLORS.wg1, color: "#fff" },
        },
        {
          field: "marginAftSplDiscPercent",
          headerName: "% MARGIN AFT SPL DISC",
          cellClass: "prectangePriceRightAlign",
          cellStyle: { backgroundColor: COLORS.wg1, color: "#fff" },
          minWidth: 80,
          cellRenderer: showDiscountPercent,
        },
        {
          field: "gestureToCustomer",
          headerName: "GESTURE TO CUSTOMER",
          cellClass: "prectangePriceRightAlign",
          cellStyle: { backgroundColor: COLORS.wg1, color: "#fff" },
          minWidth: 70,
          cellRenderer: showFixedValue,
        },
        {
          field: "gesture",
          headerName: "% GESTURE",
          valueFormatter: (params) =>
            params?.data?.gestureToCustomer / params?.data?.nmeRcblStd,
          cellRenderer: showDiscountPercent,
          cellClass: "prectangePriceRightAlign",
          cellStyle: { backgroundColor: COLORS.wg1, color: "#fff" },
          minWidth: 70,
        },
      ],
    },
    {
      headerName: "PBL summary",
      headerClass: "grp-header grp-pbl-wg1",
      marryChildren: true,
      children: [
        {
          field: "nmeRcbl",
          headerName: "NFZE RCBL",
          cellClass: "prectangePriceRightAlign",
          cellStyle: { backgroundColor: COLORS.pblWg1, color: "#fff" },
          minWidth: 70,
          cellRenderer: showFixedValue,
        },
        {
          field: "nmePblStd",
          headerName: "NFZE PBL (STD)",
          cellStyle: { backgroundColor: COLORS.pblWg1, color: "#fff" },
          minWidth: 70,
          cellClass: "prectangePriceRightAlign",
          cellRenderer: showFixedValue,
        },
        {
          field: "nmePblAfterSdp",
          cellClass: "prectangePriceRightAlign",
          headerName: "NFZE PBL (AFTER SDP)",
          cellStyle: { backgroundColor: COLORS.pblWg1, color: "#fff" },
          minWidth: 80,
          cellRenderer: showFixedValue,
        },
        {
          field: "stdPblMargin",
          cellClass: "prectangePriceRightAlign",
          headerName: "STD MARGIN",
          cellStyle: { backgroundColor: COLORS.pblWg1, color: "#fff" },
          minWidth: 70,
          cellRenderer: showFixedValue,
        },
        {
          field: "pblMarginAftSplDisc",
          cellClass: "prectangePriceRightAlign",
          headerName: "NFZE MARGIN AFT SPL DISC",
          cellStyle: { backgroundColor: COLORS.pblWg1, color: "#fff" },
          minWidth: 70,
          cellRenderer: showFixedValue,
        },
        {
          field: "pblMarginAftSplDiscPercent",
          cellClass: "prectangePriceRightAlign",
          headerName: "%NFZE MARGIN",
          cellStyle: { backgroundColor: COLORS.pblWg1, color: "#fff" },
          minWidth: 80,
          cellRenderer: showDiscountPercent,
        },
        {
          field: "gestureToPbl",
          cellClass: "prectangePriceRightAlign",
          headerName: "NFZE GESTURE",
          cellStyle: { backgroundColor: COLORS.pblWg1, color: "#fff" },
          minWidth: 70,
          cellRenderer: showFixedValue,
        },
        {
          field: "gesturePbl",
          cellClass: "prectangePriceRightAlign",
          cellStyle: { backgroundColor: COLORS.pblWg1, color: "#fff" },
          headerName: "NFZE PER GESTURE",
          cellRenderer: showDiscountPercent,
          minWidth: 70,
        },
      ],
    },
    {
      headerName: "",
      headerClass: "grp-header grp-neutral",
      marryChildren: true,
      children: [
        {
          field: "specialDiscountFile",
          minWidth: 60,
          headerName: "Document",
          cellRenderer: showAttachment,
        },
        {
          field: "sdrStatus",
          minWidth: 70,
          filter: "agTextColumnFilter",
          editable: false,
        },
      ],
    },
  ]);

  const onGridReady = useCallback((params) => {
    setGridApi(params?.api);
  }, []);
  const handleSDRRejected = async () => {
    try {
      const firstRow = selectedRows[0];
      let model = {
        specialDiscountId: id,
        sdrWg1: firstRow?.sdrWg1 || 0,
        sdrWg2: firstRow?.sdrWg2 || 0,
        specialDiscType: "SDR",
        status: "REJECTED",
      };

      const approveUrl = await OAuthService.addData(
        discountUrl + "api/approveSpecialDiscount",
        model,
      );
      toast.warn("SDR discount rejected successfully.");
      fetchProjectData();
      getSpecialDiscountById(id);
    } catch (error) {
      toast.error(error?.response?.data?.errorMessage || error.message);
    }
  };
  const handleSDRApprove = async () => {
    try {
      const firstRow = selectedRows[0];

      let model = {
        specialDiscountId: id,
        sdrWg1: firstRow?.sdrWg1 || 0,
        sdrWg2: firstRow?.sdrWg2 || 0,
        specialDiscType: "SDR",
        status: "APPROVED",
      };

      await OAuthService.addData(
        discountUrl + "api/approveSpecialDiscount",
        model,
      );
      toast.success("SDR discount approved successfully.");
      fetchProjectData();
      getSpecialDiscountById(id);
    } catch (error) {
      toast.error(error?.response?.data?.errorMessage || error.message);
    }
  };
  const onFirstDataRendered = useCallback(() => {
    if (!isMobile) {
    const allColumnIds = [];
    gridRef.current.columnApi.getColumns().forEach((column) => {
      allColumnIds.push(column.getId());
    });
    gridRef.current.columnApi.autoSizeColumns(allColumnIds, false);
  }
  }, []);
  const onSelectionChanged = (params) => {
    const selectedNodes = gridApi?.getSelectedNodes();
    const selectedRowsData = selectedNodes?.map((node) => node.data);
    const selectedRowIds = selectedNodes?.map((n) => n.id);
    setSelectedRows(selectedRowsData);
    setSelectedRowsID(selectedRowIds);
  };
  const isValidPercent = (v) => {
    if (v === null || v === undefined || v === "") return true;
    const n = Number(v);
    return !Number.isNaN(n) && Number.isFinite(n) && n <= 100;
  };
  const handleSDRSave = async () => {
    const orderIds = selectedRows.map((item) => item.id);
    const selectedRowsID = selectedRows.map((item) => item.id);
    const firstRow = selectedRows[0];
    if (!isValidPercent(firstRow.sdrWg1) || !isValidPercent(firstRow.sdrWg2)) {
      toast.error("SDR WG1/WG2 must be valid numbers .");
      return;
    }
    const model = {
      orderId: orderIds,
      sdrWg1: firstRow.sdrWg1 || 0,
      sdrWg2: firstRow.sdrWg2 || 0,

      comment: comment || "",
      specialDiscType: "SDR",
      status: firstRow?.sdrStatus === "PENDING" ? "PENDING" : "WAITING",
      specialDiscountId: id || "",
    };

    try {
      await OAuthService.addData(discountUrl + "api/addSpecialDiscount", model);
      toast.success("SDR discount saved successfully.");

      fetchProjectData();
      getSpecialDiscountById(id);
      setTimeout(() => {
        selectedRowsID.forEach((id) => {
          gridApi?.getRowNode(id)?.setSelected(true);
        });
      }, 100);
    } catch (error) {
      toast.error(error?.response?.data?.errorMessage || error.message);
    }
  };
  const handleSDRSaveEmail = async () => {
    const orderIds = selectedRows.map((item) => item.id);
    const firstRow = selectedRows[0];
    const hasMD = token?.scope?.includes("ROLE_MD");
    const model = {
      orderId: orderIds,
      sdrWg1: firstRow.sdrWg1 || 0,
      sdrWg2: firstRow.sdrWg2 || 0,

      comment: comment || "",
      specialDiscType: "SDR",
      status: hasMD && sdrData?.status === "APPROVED" ? "APPROVED" : "PENDING",
      specialDiscountId: id || "",
    };
    try {
      await OAuthService.addData(discountUrl + "api/addSpecialDiscount", model);
      toast.success("SDR discount saved successfully.");
      gridApi?.deselectAll();

      setSelectedRows([]);
      setSelectedRowsID([]);
      fetchProjectData();
      getSpecialDiscountById(id);
    } catch (error) {
      toast.error(error?.response?.data?.errorMessage || error.message);
    }
  };

  const handleUpdateSDRCellValue = () => {
    if (selectedRows.length > 0) {
      const colId1 = "sdrWg1";
      const colId2 = "sdrWg2";

      const updatedData = rowData.map((row) => {
        const isSelected = selectedRows.some((r) => r.id === row.id);
        if (!isSelected) return row;

        const newRow = { ...row };

        newRow[colId1] = wg1SDR !== "" ? Number(wg1SDR) : row?.sdrWg1;
        newRow[colId2] = wg2SDR !== "" ? Number(wg2SDR) : row?.sdrWg2;

        if (newRow?.stdDiscWg1 || newRow?.sdrWg1) {
          newRow.cumDiscWg1 =
            100 -
            ((100 - Number(newRow?.rcblStdDiscWg1)) *
              (100 - Number(newRow?.sdrWg1))) /
              100;
        } else {
          newRow.cumDiscWg1 = 0;
        }

        if (newRow?.stdDiscWg2 || newRow?.sdrWg2) {
          newRow.cumDiscWg2 =
            100 -
            ((100 - Number(newRow?.rcblStdDiscWg2)) *
              (100 - Number(newRow?.sdrWg2))) /
              100;
        } else {
          newRow.cumDiscWg2 = 0;
        }

        if (
          newRow?.rcblStdDiscWg1 ||
          newRow?.rcblStdDiscWg2 ||
          newRow?.revisedLpWg1 ||
          newRow?.revisedLpWg2
        ) {
          newRow.nmeRcblStd =
            Number(newRow?.revisedLpWg1) -
            Number(newRow?.revisedLpWg1) *
              (Number(newRow?.rcblStdDiscWg1) / 100) +
            (Number(newRow?.revisedLpWg2) -
              Number(newRow?.revisedLpWg2) *
                (Number(newRow?.rcblStdDiscWg2) / 100));
        } else {
          newRow.nmeRcblStd = "";
        }

        if (newRow?.pblStdDiscWg1 || newRow?.sdpWg1) {
          newRow.pblCumDiscWg1 =
            100 -
            ((100 - Number(newRow?.pblStdDiscWg1)) *
              (100 - Number(newRow?.sdpWg1))) /
              100;
        } else {
          newRow.pblCumDiscWg1 = 0;
        }

        if (
          newRow?.cumDiscWg1 ||
          newRow?.cumDiscWg2 ||
          newRow?.revisedLpWg1 ||
          newRow?.revisedLpWg2
        ) {
          newRow.nmeRcbl =
            Number(newRow?.revisedLpWg1) -
            Number(newRow?.revisedLpWg1) * (Number(newRow?.cumDiscWg1) / 100) +
            Number(newRow?.revisedLpWg2) -
            Number(newRow?.revisedLpWg2) * (Number(newRow?.cumDiscWg2) / 100);
        } else {
          newRow.nmeRcbl = "";
        }

        if (newRow?.pblStdDiscWg2 || newRow?.sdpWg2) {
          newRow.pblCumDiscWg2 =
            100 -
            ((100 - Number(newRow?.pblStdDiscWg2)) *
              (100 - Number(newRow?.sdpWg2))) /
              100;
        } else {
          newRow.pblCumDiscWg2 = 0;
        }

        if (
          newRow?.cumDiscWg2 ||
          newRow?.cumDiscWg1 ||
          newRow?.revisedLpWg1 ||
          newRow?.revisedLpWg2
        ) {
          newRow.nmeRcblAfterSdr =
            Number(newRow?.revisedLpWg1) -
            Number(newRow?.revisedLpWg1) * (Number(newRow?.cumDiscWg1) / 100) +
            (Number(newRow?.revisedLpWg2) -
              Number(newRow?.revisedLpWg2) *
                (Number(newRow?.cumDiscWg2) / 100));
        } else {
          newRow.nmeRcblAfterSdr = "";
        }

        if (
          newRow?.pblCumDiscWg1 ||
          newRow?.pblCumDiscWg2 ||
          newRow?.revisedLpWg1 ||
          newRow?.revisedLpWg2
        ) {
          newRow.nmePbl =
            Number(newRow?.revisedLpWg1) -
            Number(newRow?.revisedLpWg1) *
              (Number(newRow?.pblCumDiscWg1) / 100) +
            (Number(newRow?.revisedLpWg2) -
              Number(newRow?.revisedLpWg2) *
                (Number(newRow?.pblCumDiscWg2) / 100));
        } else {
          newRow.nmePbl = 0;
        }
        if (
          newRow?.pblCumDiscWg1 ||
          newRow?.pblCumDiscWg2 ||
          newRow?.revisedLpWg1 ||
          newRow?.revisedLpWg2
        ) {
          newRow.nmePblAfterSdp =
            Number(newRow?.revisedLpWg1) -
            Number(newRow?.revisedLpWg1) *
              (Number(newRow?.pblCumDiscWg1) / 100) +
            (Number(newRow?.revisedLpWg2) -
              Number(newRow?.revisedLpWg2) *
                (Number(newRow?.pblCumDiscWg2) / 100));
        } else {
          newRow.nmePblAfterSdp = 0;
        }
        if (newRow?.nmeRcblAfterSdr || newRow?.nmePbl) {
          newRow.marginAftSplDisc =
            Number(newRow?.nmeRcblAfterSdr) - Number(newRow?.nmePbl);
        } else {
          newRow.marginAftSplDisc = "";
        }

        if (newRow?.marginAftSplDisc && newRow?.nmeRcblAfterSdr) {
          newRow.marginAftSplDiscPercent =
            (Number(newRow?.marginAftSplDisc) /
              Number(newRow?.nmeRcblAfterSdr)) *
            100;
        } else {
          newRow.marginAftSplDiscPercent = "";
        }

        if (newRow?.nmeRcblStd || newRow?.nmeRcblAfterSdr) {
          newRow.gestureToCustomer =
            Number(newRow?.nmeRcblStd) - Number(newRow?.nmeRcblAfterSdr);
        } else {
          newRow.gestureToCustomer = "";
        }

        if (newRow?.gestureToCustomer || newRow?.nmeRcblStd) {
          newRow.gesture =
            (Number(newRow?.gestureToCustomer) / Number(newRow?.nmeRcblStd)) *
            100;
        } else {
          newRow.gesture = "";
        }

        if (newRow?.nmeRcblStd || newRow?.nmePbl) {
          newRow.stdMargin =
            Number(newRow?.nmeRcblStd) - Number(newRow?.nmePbl);
        } else {
          newRow.stdMargin = "";
        }

        if (
          newRow?.pblStdDiscWg1 ||
          newRow?.pblStdDiscWg2 ||
          newRow?.revisedLpWg1 ||
          newRow?.revisedLpWg2
        ) {
          newRow.nmePblStd =
            Number(newRow?.revisedLpWg1) -
            Number(newRow?.revisedLpWg1) *
              (Number(newRow?.pblStdDiscWg1) / 100) +
            (Number(newRow?.revisedLpWg2) -
              Number(newRow?.revisedLpWg2) *
                (Number(newRow?.pblStdDiscWg2) / 100));
        } else {
          newRow.nmePblStd = 0;
        }

        if (
          newRow?.pblCumDiscWg1 ||
          newRow?.pblCumDiscWg2 ||
          newRow?.revisedLpWg1 ||
          newRow?.revisedLpWg2
        ) {
          newRow.nmePblAfterSdr =
            Number(newRow?.revisedLpWg1) -
            Number(newRow?.revisedLpWg1) *
              (Number(newRow?.pblCumDiscWg1) / 100) +
            (Number(newRow?.revisedLpWg2) -
              Number(newRow?.revisedLpWg2) *
                (Number(newRow?.pblCumDiscWg2) / 100));
        } else {
          newRow.nmePblAfterSdr = 0;
        }

        if (newRow?.nmePblStd || newRow?.nmeRcbl) {
          newRow.stdPblMargin =
            Number(newRow?.nmeRcbl) - Number(newRow?.nmePblStd);
        } else {
          newRow.stdPblMargin = 0;
        }

        if (newRow?.nmePblAfterSdp || newRow?.nmeRcbl) {
          newRow.pblMarginAftSplDisc =
            Number(newRow?.nmeRcbl) - Number(newRow?.nmePblAfterSdp);
        } else {
          newRow.pblMarginAftSplDisc = 0;
        }

        if (newRow?.pblMarginAftSplDisc || newRow?.nmeRcbl) {
          newRow.pblMarginAftSplDiscPercent =
            (Number(newRow?.pblMarginAftSplDisc) / Number(newRow?.nmeRcbl)) *
            100;
        } else {
          newRow.pblMarginAftSplDiscPercent = 0;
        }

        if (newRow?.nmePblStd || newRow?.nmePblAfterSdp) {
          newRow.gestureToPbl =
            Number(newRow?.nmePblStd) - Number(newRow?.nmePblAfterSdp);
        } else {
          newRow.gestureToPbl = 0;
        }

        if (newRow?.gestureToPbl || newRow?.nmePblStd) {
          newRow.gesturePbl =
            (Number(newRow?.gestureToPbl) / Number(newRow?.nmePblStd)) * 100;
        } else {
          newRow.gesturePbl = 0;
        }

        return newRow;
      });
      setRowData(updatedData);
      toast.success("SDR values distributed for selected rows.");
      setWg1SDR("");
      setWg2SDR("");

      setTimeout(() => {
        selectedRowsID.forEach((id) => {
          gridApi?.getRowNode(id)?.setSelected(true);
        });
      }, 0);
    }
  };

  const wgButtonDisabled = useMemo(() => {
    if (!selectedRows?.length) return true;

    const hasRole = (role) => token?.scope?.includes(role);

    if (
      hasRole("ROLE_IAM") ||
      hasRole("ROLE_ORDERPRO") ||
      hasRole("ROLE_SOPDIR") ||
      hasRole("ROLE_ADMIN")
    ) {
      return !(
        sdrData.status === "WAITING" ||
        sdrData.status === "PENDING" ||
        sdrData.status === "REJECTED"
      );
    }

    if (hasRole("ROLE_MD")) {
      return !(
        sdrData.status === "WAITING" ||
        sdrData.status === "PENDING" ||
        sdrData.status === "APPROVED"
      );
    }

    return true;
  }, [selectedRows, sdrData]);

  const onBtExport = useCallback(() => {
    const params = {
      fileName: "Special Discount SDR.xlsx",
      sheetName: "SDR",
    };
    gridRef.current.api.exportDataAsExcel(params);
  }, []);

  useEffect(() => {
    onSelectionChanged();
  }, []);

  const canSeeDistribution =
    token.scope.includes("ROLE_IAM") ||
    token.scope.includes("ROLE_ADMIN") ||
    token.scope.includes("ROLE_MD") ||
    token.scope.includes("ROLE_SOPDIR");

  const isMD = token?.scope.includes("ROLE_MD");

  const TotalChip = ({ label, value, bg = COLORS.neutral }) => (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1,
        px: 1.5,
        py: 1,
        borderRadius: 1.5,
        border: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.background.paper,
      }}
    >
      <Typography
        variant="caption"
        sx={{ color: theme.palette.text.secondary, fontWeight: 600 }}
      >
        {label}
      </Typography>
      <Box
        sx={{
          background: bg,
          color: "#fff",
          borderRadius: 1,
          px: 1.5,
          py: 0.5,
          fontSize: 13,
          fontWeight: 700,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {value}
      </Box>
    </Box>
  );

  return (
     <div
        style={{
          display: "flex",
          flexDirection: "column",
          flex: "1 1 auto",
          minHeight: 0,
        }}
      >
      <style>{`
        .grp-header.grp-neutral { background-color: #7C8794 !important; color: #fff !important; }
        .grp-header.grp-wg1 { background-color: ${COLORS.wg1} !important; color: #fff !important; }
        .grp-header.grp-wg2 { background-color: ${COLORS.wg2} !important; color: #fff !important; }
        .grp-header.grp-pbl-wg1 { background-color: ${COLORS.pblWg1} !important; color: #fff !important; }
        .grp-header.grp-pbl-wg2 { background-color: ${COLORS.pblWg2} !important; color: #fff !important; }
        .grp-header .ag-header-group-text { font-weight: 700; font-size: 11px; letter-spacing: .02em; }
      `}</style>

      <FormPageHeader
        componentName="Special Discount Details"
        pageName="Special Discount Details"
        currentPage={`Special Discount Order Details - ${sdrData?.project}`}
        onBtExport={onBtExport}
      >
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr 1fr",
              sm: "repeat(3, 1fr)",
              md: "repeat(5, 1fr)",
            },
            gap: 1,
            px: 3,
            pt: 2,
            pb: 1,
          }}
        >
          <TotalChip
            label="Total List Price"
            value={totalsGroup?.totalListPrice}
            bg={COLORS.neutral}
          />
          <TotalChip
            label="RCBL as per PDS"
            value={totalsGroup?.totalRCBLSTD}
            bg={COLORS.wg1}
          />
          <TotalChip
            label="RCBL as per SDR"
            value={totalsGroup?.totalRCBAftSDR}
            bg={COLORS.wg1}
          />
          <TotalChip
            label="Gesture to Cust."
            value={totalsGroup?.totalGestureCustomer}
            bg={COLORS.wg1}
          />
          <TotalChip
            label="% Gesture to Cust."
            value={`${totalsGroup?.perGestureCust ?? 0} %`}
            bg={COLORS.wg1}
          />
          <TotalChip
            label="Total Orders"
            value={totalsGroup?.TotalOrder}
            bg={COLORS.neutral}
          />

          <TotalChip
            label="PBL as per PDS"
            value={totalsGroup?.totalPBLPDS}
            bg={COLORS.pblWg1}
          />
          <TotalChip
            label="PBL as per SDP"
            value={totalsGroup?.totalPBLAftSDP}
            bg={COLORS.pblWg1}
          />
          <TotalChip
            label="Gest from factory"
            value={totalsGroup?.totalGestureFac}
            bg={COLORS.pblWg1}
          />
          <TotalChip
            label="% Gesture on PBL"
            value={`${totalsGroup?.totalPercentageGesture ?? 0}%`}
            bg={COLORS.pblWg1}
          />
          <Box />
          <TotalChip
            label="Margin as per PDS"
            value={totalsGroup?.totalMarginPDS}
            bg={COLORS.neutral}
          />
          <TotalChip
            label="Margin after SDR"
            value={totalsGroup?.totalMarginAftSDR}
            bg={COLORS.neutral}
          />
          <TotalChip
            label=" % Margin"
            value={`${totalsGroup?.totalMarginPercentage ?? 0}%`}
            bg={COLORS.neutral}
          />
        </Box>

        <Divider sx={{ mx: 3 }} />

        <Box sx={{ px: 3, py: 2 }}>
          <Typography
            variant="subtitle2"
            sx={{ fontWeight: 700, mb: 1.5, color: theme.palette.text.primary }}
          >
            SDR Distribution
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "flex-end",
              gap: 2,
            }}
          >
            <Box sx={{ flex: "1 1 320px", minWidth: 250 }}>
              <Typography
                variant="caption"
                sx={{
                  display: "block",
                  mb: 0.5,
                  fontWeight: 600,
                  color: theme.palette.text.secondary,
                }}
              >
                SDR Comment
              </Typography>
              <TextField
                name="comment"
                value={comment}
                fullWidth
                multiline
                rows={1}
                disabled={
                  wgButtonDisabled ||
                  (token?.scope.includes("ROLE_ORDERPRO") &&
                    !(
                      token.scope.includes("ROLE_ADMIN") ||
                      token.scope.includes("ROLE_MD") ||
                      token.scope.includes("ROLE_SOPDIR") ||
                      token.scope.includes("ROLE_IAM")
                    ))
                }
                onChange={(e) => setComment(e.target.value)}
              />
            </Box>

            {canSeeDistribution && (
              <>
                <Box sx={{ width: 110 }}>
                  <Typography
                    variant="caption"
                    sx={{
                      display: "block",
                      mb: 0.5,
                      fontWeight: 600,
                      color: theme.palette.text.secondary,
                    }}
                  >
                    WG1 SDR
                  </Typography>
                  <TextField
                    size="small"
                    type="text"
                    inputMode="decimal"
                    fullWidth
                    value={wg1SDR}
                    disabled={wgButtonDisabled}
                    onKeyDown={(e) => {
                      const allowedKeys = [
                        "Backspace",
                        "Tab",
                        "ArrowLeft",
                        "ArrowRight",
                        "Delete",
                        ".",
                        "-",
                      ];
                      if (
                        !allowedKeys.includes(e.key) &&
                        (e.key < "0" || e.key > "9")
                      ) {
                        e.preventDefault();
                        toast.warning("Only numbers are allowed!");
                        return;
                      }
                      if (e.key === "." && wg1SDR.includes(".")) {
                        e.preventDefault();
                        toast.warning("Only one decimal point is allowed!");
                        return;
                      }
                      if (e.key === "-") {
                        if (
                          wg1SDR.includes("-") ||
                          e.target.selectionStart !== 0
                        ) {
                          e.preventDefault();
                          toast.warning(
                            "'-' is only allowed once, at the start!",
                          );
                        }
                      }
                    }}
                    onChange={(e) => {
                      let value = e.target.value;
                      if (value.startsWith(".")) value = "0" + value;
                      if (value.startsWith("-.")) value = "-0" + value.slice(1);

                      const partial = /^-?(0|[1-9]\d*)?\.?\d*$/;
                      if (value === "" || partial.test(value)) {
                        setWg1SDR(value);
                      } else {
                        toast.warning("Invalid number!");
                      }
                    }}
                  />
                </Box>

                <Box sx={{ width: 110 }}>
                  <Typography
                    variant="caption"
                    sx={{
                      display: "block",
                      mb: 0.5,
                      fontWeight: 600,
                      color: theme.palette.text.secondary,
                    }}
                  >
                    WG2 SDR
                  </Typography>
                  <TextField
                    size="small"
                    type="text"
                    inputMode="decimal"
                    fullWidth
                    value={wg2SDR}
                    disabled={wgButtonDisabled}
                    onKeyDown={(e) => {
                      const allowedKeys = [
                        "Backspace",
                        "Tab",
                        "ArrowLeft",
                        "ArrowRight",
                        "Delete",
                        ".",
                        "-",
                      ];
                      if (
                        !allowedKeys.includes(e.key) &&
                        (e.key < "0" || e.key > "9")
                      ) {
                        e.preventDefault();
                        toast.warning("Only numbers are allowed!");
                        return;
                      }
                      if (e.key === "." && wg2SDR.includes(".")) {
                        e.preventDefault();
                        toast.warning("Only one decimal point is allowed!");
                        return;
                      }
                      if (e.key === "-") {
                        if (
                          wg2SDR.includes("-") ||
                          e.target.selectionStart !== 0
                        ) {
                          e.preventDefault();
                          toast.warning(
                            "'-' is only allowed once, at the start!",
                          );
                        }
                      }
                    }}
                    onChange={(e) => {
                      let value = e.target.value;
                      if (value.startsWith(".")) value = "0" + value;
                      if (value.startsWith("-.")) value = "-0" + value.slice(1);

                      const partial = /^-?(0|[1-9]\d*)?\.?\d*$/;
                      if (value === "" || partial.test(value)) {
                        setWg2SDR(value);
                      } else {
                        toast.warning("Invalid number!");
                      }
                    }}
                  />
                </Box>

                <Box sx={{ display: "flex", gap: 1, pb: "1px" }}>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={handleUpdateSDRCellValue}
                    disabled={
                      wgButtonDisabled || wg1SDR === "-" || wg2SDR === "-"
                    }
                    sx={{ fontWeight: 700 }}
                  >
                    Distribute
                  </Button>

                  {!isMD && (
                    <Tooltip title="Save">
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={handleSDRSave}
                        disabled={
                          wgButtonDisabled || wg1SDR === "-" || wg2SDR === "-"
                        }
                        sx={{ minWidth: 0, px: 1.5 }}
                      >
                        <FuseSvgIcon>material-solid:save</FuseSvgIcon>
                      </Button>
                    </Tooltip>
                  )}

                  <Tooltip title={isMD ? "Save" : "SDR EMAIL TO MD"}>
                    <Button
                      variant={isMD ? "outlined" : "contained"}
                      color="success"
                      onClick={handleSDRSaveEmail}
                      disabled={
                        wgButtonDisabled || wg1SDR === "-" || wg2SDR === "-"
                      }
                      sx={{ fontWeight: 700, minWidth: 0, px: isMD ? 1.5 : 2 }}
                    >
                      {isMD ? (
                        <FuseSvgIcon>material-solid:save</FuseSvgIcon>
                      ) : (
                        <FuseSvgIcon>heroicons-outline:mail</FuseSvgIcon>
                      )}
                    </Button>
                  </Tooltip>

                  {isMD && (
                    <>
                      <Tooltip title="Approve">
                        <Button
                          variant="contained"
                          color="success"
                          size="small"
                          onClick={handleSDRApprove}
                          disabled={
                            !(
                              selectedRows?.length > 0 &&
                              sdrData?.status === "PENDING"
                            )
                          }
                        >
                          <FuseSvgIcon>
                            heroicons-outline:check-circle
                          </FuseSvgIcon>
                        </Button>
                      </Tooltip>

                      <Tooltip title="Reject">
                        <Button
                          variant="contained"
                          color="error"
                          size="small"
                          onClick={handleSDRRejected}
                          disabled={
                            !(
                              selectedRows?.length > 0 &&
                              sdrData?.status === "PENDING"
                            )
                          }
                        >
                          <FuseSvgIcon>heroicons-outline:x-circle</FuseSvgIcon>
                        </Button>
                      </Tooltip>
                    </>
                  )}
                </Box>
              </>
            )}
          </Box>
        </Box>
      </FormPageHeader>
      <Box
        sx={{
          display: "flex",
          gap: 3,
          alignItems: "center",
          px: 3,
          pb: 1,
          flexWrap: "wrap",
        }}
      >
        {[
          ["WG1", COLORS.wg1],
          ["WG2", COLORS.wg2],
          ["SDR", COLORS.sdr],
          ["PBL WG1", COLORS.pblWg1],
          ["PBL WG2", COLORS.pblWg2],
        ].map(([label, color]) => (
          <Box
            key={label}
            sx={{ display: "flex", alignItems: "center", gap: 0.75 }}
          >
            <Box
              sx={{
                width: 10,
                height: 10,
                borderRadius: 0.5,
                backgroundColor: color,
              }}
            />
            <Typography
              variant="caption"
              sx={{ fontWeight: 600, color: theme.palette.text.secondary }}
            >
              {label}
            </Typography>
          </Box>
        ))}
      </Box>
     
        <div style={{ flex: "1 1 auto", minHeight: 400, width: "100%" }}>
          <AgGridTable
            columnDefs={columnDefsSDR}
            onGridReady={onGridReady}
            gridRef={gridRef}
            rowData={rowData}
            wrapHeaderText={true}
            onFirstDataRendered={onFirstDataRendered}
            autoHeaderHeight={true}
            onCellValueChanged={onCellValueChanged}
            domLayout={"autoHeight"}
            onSelectionChanged={onSelectionChanged}
            rowSelection={"multiple"}
            pagination={true}
            rowGroupPanelShow="never"
            editable={false}
          />
        </div>
      </div>
  );
};
export default SpecialDiscountDetail;
